// extracted by mini-css-extract-plugin
module.exports = {"menu":"ActionsPopup_menu__3F1Kx","menuItem":"ActionsPopup_menuItem__1knsI"};